module.exports = __webpack_public_path__ + "static/media/freelancer-onboarding-step-3.4d8ba199.webp";